// SEO landing pages targeting high-intent India / Bangalore search queries.
// Each config renders through <LocationPage /> — same layout, unique copy + meta.
export const LOCATION_PAGES = {
    "paper-bowl-manufacturer-bangalore": {
        title: "Paper Bowl Manufacturer in Bangalore",
        h1: "Paper Bowl Manufacturer, Bangalore",
        eyebrow: "[ Bangalore · Karnataka · India ]",
        meta: "Paper bowl manufacturer in Bangalore. The Puro Pack builds compostable paper salad bowls, soup bowls and PET flat lids — PE-coated or Aqueous-coated, food-safe, made in Bangalore.",
        seoTitle: "Paper Bowl Manufacturer Bangalore | The Puro Pack",
        intro: "The Puro Pack is a **paper bowl manufacturer in Bangalore, Karnataka**. We manufacture food-safe paper salad bowls (500–1000 ML), paper soup bowls (250–750 ML) and PET flat lids for QSRs, cloud kitchens, cafés and export customers from a factory in Bangalore.",
        bullets: [
            "Manufactured in Bangalore, Karnataka",
            "PE-coated or water-based Aqueous-coated — buyer chooses",
            "White printed + kraft brown finishes",
            "MOQ from 10,000 units · lead time from 5 days",
            "Custom printing available on all SKUs",
        ],
        searchTerms: ["paper bowl manufacturer Bangalore", "sustainable packaging Bangalore", "paper salad bowl supplier Bangalore", "kraft food bowl Bangalore"],
    },
    "paper-bowl-manufacturer-india": {
        title: "Paper Bowl Manufacturer in India",
        h1: "Paper Bowl Manufacturer, India",
        eyebrow: "[ India · Foodservice ]",
        meta: "Paper bowl manufacturer in India. The Puro Pack — Bangalore-based paper salad bowls, soup bowls & PET lids for QSRs, cloud kitchens and grocery across India.",
        seoTitle: "Paper Bowl Manufacturer India | The Puro Pack",
        intro: "The Puro Pack is a **paper bowl manufacturer in India**, headquartered in Bangalore and shipping across the country. We produce food-safe paper salad bowls, soup bowls, and PET flat lids for the modern Indian foodservice supply chain.",
        bullets: [
            "Serving India + export markets from Bangalore",
            "Compostable paper substrate, food-safe coatings",
            "Multiple size ranges for salads (500/750/1000 ML) and soups (250/350/500/750 ML)",
            "White printed and kraft brown paper variants",
            "Volume discounts + freight-optimised palletisation",
        ],
        searchTerms: ["paper bowl manufacturer India", "paper salad bowl India", "paper soup bowl India"],
    },
    "paper-food-packaging-india": {
        canonicalTo: "/paper-food-containers-manufacturer",
        title: "Paper Food Packaging in India",
        h1: "Paper Food Packaging, India",
        eyebrow: "[ India · Sustainable Packaging ]",
        meta: "Paper food packaging in India. Compostable bowls and PET flat lids from The Puro Pack — a Bangalore-based sustainable packaging manufacturer.",
        seoTitle: "Paper Food Packaging India | The Puro Pack",
        intro: "The Puro Pack supplies **paper food packaging across India** — compostable paper bowls, kraft food bowls, and food-grade PET flat lids for restaurants, quick-service brands and grocery meal-kits.",
        bullets: [
            "Food-contact certified paper substrate",
            "Two coating systems — PE and water-based Aqueous",
            "Fits universal PET flat lid @ 148 mm",
            "Print-ready surfaces for custom brand artwork",
            "Nationwide dispatch from Bangalore",
        ],
        searchTerms: ["paper food packaging India", "paper bowls India", "food safe paper packaging manufacturer"],
    },
    "sustainable-packaging-india": {
        canonicalTo: "/sustainable-food-packaging",
        title: "Sustainable Packaging Manufacturer in India",
        h1: "Sustainable Packaging Manufacturer, India",
        eyebrow: "[ Green Technology Partner · India ]",
        meta: "Sustainable packaging manufacturer in India. The Puro Pack builds compostable paper bowls in Bangalore — a Green Technology partner for QSR, cloud kitchen and grocery brands.",
        seoTitle: "Sustainable Packaging Manufacturer India | The Puro Pack",
        intro: "The Puro Pack is a **sustainable packaging manufacturer in India** and a Green Technology partner to foodservice brands. Our paper packaging is designed to give your food-safety team the same confidence as plastic, and your marketing team a story that stands up on camera.",
        bullets: [
            "Green Technology partner for the foodservice industry",
            "Compostable paper substrate + food-safe coatings",
            "No PLA blends · transparent coating chemistry",
            "FSC-mix certified fibre sources",
            "Located in Bangalore, shipping globally",
        ],
        searchTerms: ["sustainable packaging India", "eco-friendly food packaging Bangalore", "compostable bowls India"],
    },
    "salad-bowl-manufacturer-india": {
        canonicalTo: "/paper-salad-bowls-manufacturer-india",
        title: "Salad Bowl Manufacturer in India",
        h1: "Salad Bowl Manufacturer, India",
        eyebrow: "[ Paper Salad Bowls · India ]",
        meta: "Paper salad bowl manufacturer in India. The Puro Pack — 500 / 750 / 1000 ML paper salad bowls in white printed or kraft brown, PE or Aqueous coated. Made in Bangalore.",
        seoTitle: "Salad Bowl Manufacturer India | The Puro Pack",
        intro: "The Puro Pack is a **paper salad bowl manufacturer in India**, based in Bangalore. Our salad bowls come in three capacities — 500 ML, 750 ML and 1000 ML — in white printed and kraft brown finishes with either PE or Aqueous coatings.",
        bullets: [
            "500 / 750 / 1000 ML paper salad bowls",
            "GSM 300–350 · Top diameter 148 mm · Base 128 mm",
            "Lid compatible with our universal PET flat lid",
            "White printed or kraft brown paper substrate",
            "Custom printing available at 20,000 units MOQ",
        ],
        searchTerms: ["paper salad bowl manufacturer India", "kraft salad bowl India", "salad bowl Bangalore"],
    },
};
